import { render, staticRenderFns } from "./UserTrainingCourseForm.vue?vue&type=template&id=164aa553&"
import script from "./UserTrainingCourseForm.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports